import reducer from './reducers';
import * as transcriptSpeakerSelectors from './selectors';
import * as transcriptSpeakerTypes from './types';

export { transcriptSpeakerSelectors, transcriptSpeakerTypes };

export default reducer;
